import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui';
import { CheckSquare, AlertTriangle } from 'lucide-react';
import { useDashboardMetrics } from '@/hooks/queries/useDashboard';
import { WidgetSkeleton, WidgetError } from './WidgetSkeleton';
import { cn } from '@/lib/utils';

export function ActividadesWidget() {
  const { data, isLoading, isError } = useDashboardMetrics();

  if (isLoading) return <WidgetSkeleton />;
  if (isError || !data) return <WidgetError message="Error al cargar actividades" />;

  const vencidas = data.actividades.vencidas;
  const hasOverdue = vencidas > 0;

  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-sm font-medium text-gray-600">
          Actividades Pendientes
        </CardTitle>
        <div className="p-2 bg-purple-50 rounded-lg">
          <CheckSquare className="h-4 w-4 text-purple-600" />
        </div>
      </CardHeader>
      <CardContent>
        <div className="text-2xl font-bold">{data.actividades.pendientes}</div>
        <div className="flex items-center gap-1 mt-1">
          {hasOverdue && <AlertTriangle className="h-3 w-3 text-red-500" />}
          <p className={cn(
            'text-xs',
            hasOverdue ? 'text-red-600' : 'text-gray-500'
          )}>
            {hasOverdue ? `${vencidas} vencidas` : `${data.actividades.completadas_hoy} completadas hoy`}
          </p>
        </div>
      </CardContent>
    </Card>
  );
}
